// extracted by mini-css-extract-plugin
export default {"hideHomeOnMobile":"AppBarComp_hideHomeOnMobile__jCTPT"};